import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { IDashboardWidget } from "@app/main/modules/dashboard/_models/IDashboardWidget";
import { DateService } from "@app/services/date.service";
import { IWidgetInstance } from "../widget-container/widget-container.component";
import "./clock-widget.component.scss";

@Component({
    selector: 'clock-widgetv3',
    template: require("./clock-widget.component.html")
})
export class ClockWidgetComponent implements IWidgetInstance, OnInit, OnDestroy {

    @Input() widget: IDashboardWidget;

    time: string;
    date: string;

    intervalPromise: any;
    hideTitleRow = true;

    constructor(private readonly dateService: DateService) {
    }

    ngOnInit(): void {

        this.updateTime();

        this.intervalPromise = setInterval(() => {
            this.updateTime();
        }, 10_000);
    }

    ngOnDestroy() {
        clearInterval(this.intervalPromise);
    }

    // ---

    private updateTime() {
        this.time = this.dateService.formatDate(new Date(), { timeOnly: true });

        this.date = this.dateService.formatDate(new Date(), { timeOnly: false, longMonth: true });
    }
}
